// src/services/mealService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  MEAL_LIST,
  REFUND_TRANSACTION_LIST,
  REFUND_TRANSACTION_CREATE,
  COOLER_BAG_REFUND,
  MEAL_ADD,
  MEAL_UPDATE,
  MEAL_DELETE,
  REFUND_DETAIL,
  REFUND_EXPORT,
  STAFF_ADD,
} from "../../config/constants"; // Adjust endpoints as per your config

const refundService = createApi({
  reducerPath: "refundService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Refund"],
  endpoints: (builder) => ({
    getRefund: builder.query({
      query: (bodyData) => ({
        url: REFUND_TRANSACTION_LIST, // Endpoint to fetch meal list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Refund"],
    }),
    addRefund: builder.mutation({
      query: (mealData) => ({
        url: REFUND_TRANSACTION_CREATE, // Endpoint to add a meal
        method: "POST",
        data: mealData, // Meal data for the request body
      }),
      invalidatesTags: ["Refund"],
    }),

    addCoolerBag: builder.mutation({
      query: (mealData) => ({
        url: COOLER_BAG_REFUND, // Endpoint to add a meal
        method: "POST",
        data: mealData, // Meal data for the request body
      }),
      invalidatesTags: ["Refund"],
    }),

    getRefundDetails: builder.query({
      query: (id) => ({
        url: `${REFUND_DETAIL}/${id}`, // Endpoint to fetch user details
        method: "GET",
      }),
    }),

    addStaff: builder.mutation({
      query: (mealData) => ({
        url: STAFF_ADD, // Endpoint to add a staff
        method: "POST",
        data: mealData, // Meal data for the request body
      }),
      invalidatesTags: ["Refund"],
    }),

    updateMeal: builder.mutation({
      query: ({ mealId, updatedData }) => ({
        url: `${MEAL_UPDATE}/${mealId}`, // Endpoint to update a meal
        method: "PUT",
        data: updatedData, // Updated meal data
      }),
      invalidatesTags: ["Refund"]
    }),
    deleteMeal: builder.mutation({
      query: (mealId) => ({
        url: `${MEAL_DELETE}/${mealId}`, // Endpoint to delete a meal
        method: "DELETE",
      }),
      invalidatesTags: ["Refund"],
    }),
    getRefundExportFile: builder.mutation({
      query: (bodyData) => ({
        url: REFUND_EXPORT, // Endpoint to fetch ingredient list
        method: "GET",
      }),
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetRefundQuery,
  useGetRefundDetailsQuery,
  useAddRefundMutation,
  useAddCoolerBagMutation,
  useAddStaffMutation,
  useUpdateMealMutation,
  useDeleteMealMutation,
  useGetRefundExportFileMutation,
} = refundService;

// Export the reducer to be included in the store
export default refundService;
